import axiosInstance from "../utils/axiosInstance";

export interface ItineraryTag {
  id: string;
  name: string;
}

class TaggedToursApi {
  private static readonly PER_PAGE = 500;

  getTagsByItinerary(): Promise<Record<number, ItineraryTag[]>> {
    const apiUrl = `/b2c2b/api/v1/tagged_tours?per=${TaggedToursApi.PER_PAGE}`;

    return axiosInstance.get(apiUrl).then((response) => {
      const rows = response.data?.data || [];
      const map: Record<number, ItineraryTag[]> = {};

      rows.forEach((row: any) => {
        const { itinerary_id: itineraryId, primary_tag: primaryTag, other_tags: otherTags } = row.attributes || {};
        if (!itineraryId) return;

        const existing = map[itineraryId] || (map[itineraryId] = []);
        [primaryTag, ...(otherTags || [])].forEach((tag: any) => {
          if (!tag?.id || !tag?.name) return;
          const id = String(tag.id);
          if (!existing.some((seen) => seen.id === id)) existing.push({ id, name: tag.name });
        });
      });

      return map;
    });
  }
}

export default new TaggedToursApi();
